import gql from 'graphql-tag';

export const toolBySlug = gql`
  query tool($id: ID!) {
    tool(id: $id) {
      id
      imageUrl
      thumbUrl
      name
      slug
      verified
      websiteUrl
      function {
        name
        slug
      }
      layer {
        name
        slug
      }
      category {
        name
        slug
      }
    }
  }
`;

export const relatedStackups = gql`
  query relatedStackups($id: ID!, $after: String) {
    tool(id: $id) {
      relatedStackups(first: 100, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            path
            services {
              id
              name
              imageUrl
              thumbUrl
            }
          }
        }
      }
    }
  }
`;
